import React from 'react';
import { QuotaStats } from '../types';

interface HeaderProps {
  onConfigClick: () => void;
  isMapInitialized: boolean;
  quotaStats: QuotaStats;
  onResetQuota: () => void;
}

const Header: React.FC<HeaderProps> = ({
  onConfigClick,
  isMapInitialized,
  quotaStats,
  onResetQuota
}) => {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">批量地址地图显示</h1>
          <div className="header-subtitle">
            基于高德地图API的批量地址解析和显示工具
          </div>
        </div>

        <div className="header-right">
          <div className="quota-info">
            <div className="quota-stats">
              <span className="quota-item">
                请求数: {quotaStats.requestCount}
              </span>
              <span className="quota-item">
                延迟: {quotaStats.currentDelayMs}ms
              </span>
              {quotaStats.quotaExceeded && (
                <span className="quota-warning">
                  配额超限
                </span>
              )}
            </div>
            <button
              className="btn btn-secondary btn-sm"
              onClick={onResetQuota}
              title="重置配额统计"
            >
              重置
            </button>
          </div>

          <button
            className="btn btn-primary"
            onClick={onConfigClick}
          >
            {isMapInitialized ? '重新配置' : '配置密钥'}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
